if (!customElements.get('np-couples-shop')) customElements.define('np-couples-shop', class extends HTMLElement {
  async connectedCallback() {
    if(this.ready) return;
    this.ready=true;
    this.cards=[...this.querySelectorAll('[data-handle]')];
    this.groups=Object.fromEntries(this.cards.map(card=>{ const groups=(card.dataset.groups||'together').split(','); return [card.dataset.handle,groups.length>1?groups.filter(group=>group!=='together'):groups]; }));
    this.buttons=[...this.querySelectorAll('[data-group]')];
    this.group='all';
    this.available=this.querySelector('[data-available][type="checkbox"]');
    this.sort=this.querySelector('[data-sort]');
    this.buttons.forEach(button=>button.addEventListener('click',()=>{this.group=button.dataset.group;this.update();}));
    this.available.addEventListener('change',()=>this.update());
    this.sort.addEventListener('change',()=>this.update());
    this.querySelector('[data-reset]').addEventListener('click',()=>{this.group='all';this.available.checked=false;this.sort.value='featured';this.update();});
    this.querySelector('.np-couples-controls').hidden=false;
    this.update();
  }
  update() {
    const matches=(card,group)=>group==='all'||(this.groups[card.dataset.handle]||['together']).includes(group);
    const available=card=>!this.available.checked||card.dataset.available==='true';
    this.buttons.forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.group===this.group));button.querySelector('[data-count]').textContent=`(${this.cards.filter(c=>matches(c,button.dataset.group)&&available(c)).length})`;});
    const sorted=[...this.cards].sort((a,b)=>this.sort.value==='name'?a.dataset.title.localeCompare(b.dataset.title):this.sort.value==='price-asc'?Number(a.dataset.price)-Number(b.dataset.price):this.sort.value==='price-desc'?Number(b.dataset.price)-Number(a.dataset.price):Number(a.dataset.order)-Number(b.dataset.order));
    const grid=this.querySelector('[data-couples-grid]');let count=0;
    for(const card of sorted){card.hidden=!(matches(card,this.group)&&available(card));if(!card.hidden) count++;grid.append(card);}
    this.querySelector('[data-results]').textContent=`${count} ${count===1?'ornament':'ornaments'}`;
    this.querySelector('[data-empty]').hidden=count!==0;
  }
});
